import React, { useCallback, useState } from 'react';

import {
  Page,
  Card,
  Stack,
  Layout,
  TextStyle,
  TextContainer,
  Button,
  Modal,
  TextField,
  Select,
} from '@shopify/polaris';

import moment from 'moment-timezone';
import axios from 'axios';

import shippingCarrierOptions from './util/shippingCarrierOptions';

export default function SingleOrder(props) {
  const { selectedOrder } = props;

  const [fulfilledButtonLoading, setFulfilledButtonLoading] = useState(false);
  const [isOrderFulfilled, setIsOrderFulfilled] = useState(false);

  const [fulfilledModalActive, setFulfilledModalActive] = useState(false);

  const [selectedShippingCarrier, setSelectedShippingCarrier] = useState('');

  const shippingCarrierChangeHandler = useCallback(
    (value) => setSelectedShippingCarrier(value),
    []
  );

  const [trackingNumber, setTrackingNumber] = useState('');

  const trackingNumberChangeHandle = useCallback(
    (newValue) => {
      setTrackingNumber(newValue);
      if (!selectedShippingCarrier) {
        setSelectedShippingCarrier('Other');
      }
    },
    [selectedShippingCarrier]
  );

  const [trackingUrl, setTrackingUrl] = useState('');

  const trackingUrlChangeHandle = useCallback(
    (newValue) => setTrackingUrl(newValue),
    []
  );

  const fulfilledModalChangeHandler = useCallback(
    () => setFulfilledModalActive(!fulfilledModalActive),
    [fulfilledModalActive]
  );

  const fulfilledHandler = useCallback(() => {
    setFulfilledButtonLoading(true);
    const vToken = localStorage.getItem('v_token');

    const trackingMethod = {};

    if (selectedShippingCarrier === 'Other') {
      trackingMethod.tracking_company = selectedShippingCarrier;
      trackingMethod.tracking_urls = [trackingUrl];
    } else {
      trackingMethod.tracking_company = selectedShippingCarrier;
    }

    const params = {
      line_items: selectedOrder.line_items,
      tracking_numbers: [trackingNumber],
      ...trackingMethod,
    };

    axios
      .post('/fulfilled_order', {
        vToken,
        orderId: selectedOrder.id,
        params,
      })
      .then(({ data }) => {
        props.setVendorOrders((vendorOrders) =>
          vendorOrders.filter((e) => e.id !== selectedOrder.id)
        );
        setIsOrderFulfilled(true);
        fulfilledModalChangeHandler();
        props.setToast({
          content: 'Successfully Items Fulfilled!!',
          error: false,
        });
      })
      .catch((err) => {
        props.setToast({ content: err?.response?.data?.err, error: true });
        console.log(err);
      })
      .finally(() => {
        setFulfilledButtonLoading(false);
      });
  }, [
    fulfilledModalChangeHandler,
    props,
    selectedOrder.id,
    selectedOrder.line_items,
    selectedShippingCarrier,
    trackingNumber,
    trackingUrl,
  ]);
  return (
    <div className="SingleOrder">
      <Page
        breadcrumbs={[
          {
            content: 'All Orders',
            onAction: () => props.setSelectedOrder(null),
          },
        ]}
        title={selectedOrder.name}
        subtitle={moment(new Date(selectedOrder.created_at))
          .tz('Canada/Pacific')
          .format('lll')}
      >
        <Layout>
          <Layout.Section oneHalf>
            <Card sectioned title="Unfulfilled">
              {selectedOrder.line_items.map((singleProduct) => (
                <Card.Section key={singleProduct.id}>
                  <Stack>
                    <Stack.Item fill>
                      <Stack vertical={true} spacing="extraTight">
                        <TextStyle variation="strong">
                          {singleProduct.name}
                        </TextStyle>

                        <TextStyle variation="subdued">
                          SKU: {singleProduct.sku}
                        </TextStyle>
                        <div style={{ marginBottom: 5 }} />
                        {singleProduct.properties.map((singleProperty, i) => (
                          <TextContainer key={singleProperty.name}>
                            <Stack spacing="extraTight">
                              <TextStyle variation="subdued">
                                {singleProperty.name}:{' '}
                              </TextStyle>
                              {checkImageURL(singleProperty.value) ? (
                                <img
                                  onClick={() =>
                                    window.open(singleProperty.value)
                                  }
                                  style={{
                                    maxWidth: '100%',
                                    cursor: 'pointer',
                                  }}
                                  src={singleProperty.value}
                                  alt={singleProperty.value}
                                />
                              ) : (
                                <p>{singleProperty.value}</p>
                              )}
                            </Stack>
                            {singleProduct.properties.length - 1 !== i && (
                              <div
                                style={{
                                  borderBottom: '1px solid #ebeef0',
                                  marginBottom: 4,
                                }}
                              />
                            )}
                          </TextContainer>
                        ))}
                      </Stack>
                    </Stack.Item>
                  </Stack>
                </Card.Section>
              ))}
              <Card.Section>
                <Stack>
                  <Stack.Item fill />
                  <Stack.Item>
                    <Button
                      disabled={isOrderFulfilled}
                      primary
                      onClick={fulfilledModalChangeHandler}
                    >
                      Mark as fulfilled
                    </Button>
                  </Stack.Item>
                </Stack>
              </Card.Section>
            </Card>
          </Layout.Section>
          <Layout.Section oneThird>
            <Card sectioned title="SHIPPING ADDRESS">
              <p> {selectedOrder?.shipping_address?.name}</p>
              <p> {selectedOrder?.shipping_address?.address1}</p>
              <p>
                {selectedOrder?.shipping_address?.city}{' '}
                {selectedOrder?.shipping_address?.zip}
              </p>
              <p> {selectedOrder?.shipping_address?.country}</p>
              <p> {selectedOrder?.shipping_address?.phone}</p>
            </Card>
          </Layout.Section>
        </Layout>

        {/* Fulfillment Modal */}

        <Modal
          open={fulfilledModalActive}
          onClose={fulfilledModalChangeHandler}
          title="Fulfill Order"
          primaryAction={{
            content: 'Fulfill Items',
            onAction: fulfilledHandler,
            loading: fulfilledButtonLoading,
          }}
        >
          <Modal.Section>
            <Stack vertical={true}>
              <TextContainer>
                <TextStyle variation="strong">TRACKING INFORMATION</TextStyle>
              </TextContainer>
              <Stack>
                <Stack.Item fill>
                  <TextField
                    label="Tracking number"
                    value={trackingNumber}
                    onChange={trackingNumberChangeHandle}
                  />
                </Stack.Item>
                <Stack.Item fill>
                  <Select
                    label="Shipping carrier"
                    placeholder="Select"
                    options={shippingCarrierOptions}
                    onChange={shippingCarrierChangeHandler}
                    value={selectedShippingCarrier}
                  />
                </Stack.Item>
              </Stack>
              {selectedShippingCarrier === 'Other' && (
                <TextField
                  label="Tracking URL"
                  helpText="Enter the tracking page link"
                  value={trackingUrl}
                  onChange={trackingUrlChangeHandle}
                />
              )}
            </Stack>
          </Modal.Section>
        </Modal>
      </Page>
    </div>
  );
}

function checkImageURL(url) {
  const newUrl = url.split('?')[0];
  return newUrl.match(/\.(jpeg|jpg|gif|png)$/) != null;
}
